import { render, staticRenderFns } from "./create-row.vue?vue&type=template&id=ddaf7602&"
import script from "./create-row.vue?vue&type=script&lang=js&"
export * from "./create-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports